'use client'

import Image from 'next/image'
import clsx from 'clsx'
import { type ReactNode } from 'react'
import useI18n from 'Hooks/useI18n'

const ACTION_BTN_CLASS =
  'relative flex items-center gap-0 rounded-full border border-white/15 bg-white/[0.06] px-3 py-1 font-regular text-[13px] font-normal leading-[14px] text-white transition hover:border-white/30 hover:bg-white/[0.1]'

type GuideActionButtonProps = {
  onClick: () => void
  icon: string
  children: ReactNode
  className?: string
  iconClassName?: string
}

export function GuideActionButton({
  onClick,
  icon,
  children,
  className,
  iconClassName,
}: GuideActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(ACTION_BTN_CLASS, className)}
    >
      <Image
        src={icon}
        alt=""
        width={24}
        height={24}
        className={clsx('h-6 w-6 shrink-0', iconClassName)}
        draggable={false}
      />
      {children}
    </button>
  )
}

type GuideActionBarProps = {
  onGuideClick: () => void
  onLoadExample: () => void
  children?: ReactNode
}

export default function GuideActionBar({
  onGuideClick,
  onLoadExample,
  children,
}: GuideActionBarProps) {
  const { t } = useI18n()
  return (
    <div className="mt-2 flex items-center gap-2">
      <GuideActionButton onClick={onGuideClick} icon="/create/create-guide.png">
        {t('Creation Guide')}
      </GuideActionButton>
      <GuideActionButton onClick={onLoadExample} icon="/create/example.png">
        {t('Load Official Example')}
      </GuideActionButton>
      {children}
    </div>
  )
}
